import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { Link, useNavigate } from 'react-router-dom'

export default function User_control() {

  const navigate = useNavigate();
  const [companyname, setCompanyname] = useState('');
  const [listMembersArray, setListMembersArray] = useState([]);
  const [selectedComLogo, setSelectedComLogo] = useState('');
  const [roles, setRoles] = useState([]);
  const [memberRoles, setMemberRoles] = useState({});
  const [showAlertBox, setShowAlertBox] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  useEffect(() => {
    let comname = localStorage.getItem('mem_company_name');
    setCompanyname(comname);
    var comlogo = localStorage.getItem('companylogo');
    setSelectedComLogo(comlogo);
    loadMemberList();
  }, []);

  function loadMemberList() {
    let com_id = localStorage.getItem('mem_company_id');
    var obj = {
      com_id: com_id
    }
    $.ajax({
      type: 'POST',
      url: 'getAllCompanyMember.php',
      data: obj,
      cache: false,
      success: function (result) {
        var res = result;
        console.log(res);
        if (res !== 'fail' && res !== '') {
          try {
            var memarr = res;
            // ensure it's an array
            if (Array.isArray(memarr)) {
              var len = memarr.length;
              if (len < 1) {
                showAlert('Cannot find any member.');
                setListMembersArray([]);
              } else {
                setListMembersArray(memarr);
              }
            } else {
              setListMembersArray([]);
            }

          } catch (e) {
            console.error("Invalid JSON from backend:", e);
            setListMembersArray([]);
          }
        } else {
          showAlert('Cannot find any member.');
          setListMembersArray([]);
        }
      },
      error: function (xhr, status, error) {
        console.error("AJAX Error:", status, error, xhr.responseText);
      }
    });
  }

  useEffect(() => {
    if (Array.isArray(listMembersArray)) {

      const rolesObject = {};

      listMembersArray.forEach((item) => {
        rolesObject[item.primary_key] = item.permission;
      });

      setMemberRoles(rolesObject);
    }
  }, [listMembersArray]);



  useEffect(() => {
    const company_id = localStorage.getItem('mem_company_id');

    fetch('getAllDefaultroles.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({
        companyId: company_id
      })
    })
      .then(response => response.json()) // matches PHP json_encode($data)
      .then(result => {
        if (Array.isArray(result)) {
          setRoles(result);
        } else {
          console.warn("Unexpected response:", result);
        }
      })
      .catch(error => {
        console.error("Fetch Error:", error);
      });

  }, []);
  function showAlert(msg) {
    setAlertMsg(msg);
    setShowAlertBox(true);

  }

  function closeAlert() {
    setAlertMsg('');
    setShowAlertBox(false);
  }
  function removeMem(id) {
    var obj = {
      primary_key: id
    }
    $.ajax({
      type: 'POST',
      url: 'removeComMem.php',
      data: obj,
      cache: false,
      success: function (result) {
        if (result != 'fail') {
          showAlert('Removed successfully');
          navigate('/redirect_settings');
        } else {
          showAlert('Cannot remove member.');
        }
      },
    });
  }

  function updateMemRole(id, oldRoleId) {
    // selected role id
    const selectedRoleId = memberRoles[id];
    // selected role object
    const selectedRole = roles.find(
      (role) => role.primary_key == selectedRoleId
    );
    // selected role name
    const mem_role = selectedRole
      ? selectedRole.role_name
      : '';


    if (oldRoleId == selectedRoleId) {

      showAlert(
        'The user already holding the same position in your organization. Please select another role for the user.'
      );

      return;
    }

    const formData = new FormData();

    formData.append('pr_key', id);
    formData.append('memroleid', selectedRoleId);
    formData.append('memrole', mem_role);

    fetch('changeMemRole.php', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(data => {

        if (data.status === 'success') {
          console.log(data)
          loadMemberList();
          showAlert("User role updated successfully");
        } else {
          showAlert(data.message);
        }
      })
      .catch(err => {
        console.error(err);
        showAlert("Role update failed");
      });
  }

  function blockUser(id) {
    const formData = new FormData();
    formData.append('pr_key', id);
    // 👆 make sure memberId exists (from session / JS variable)

    fetch('blockUser.php', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          showAlert("User blocked successfully");
         window.location.reload();

        } else {
          showAlert(data.message);
        }
      })
      .catch(err => {
        console.error(err);
        showAlert("Image upload failed");
      });
  }

  function unblockUser(id) {
    const formData = new FormData();
    formData.append('pr_key', id);
    // 👆 make sure memberId exists (from session / JS variable)

    fetch('unblockUser.php', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          showAlert("User un-blocked successfully");
          window.location.reload();

        } else {
          showAlert(data.message);
        }
      })
      .catch(err => {
        console.error(err);
        showAlert("Image upload failed");
      });
  }
  return (
    <div>
      <div className='editbtn_holder'>
        <div className='membersinfoimg fullwidth'>
          <div className='memberimgholder'>
            <img id="memimg" src={selectedComLogo} />
          </div>
          <h2 id="companyname">{companyname}</h2>
        </div>
      </div>
      <div className='vl_alltab'>
        <button className='tabs'>User List of {companyname} </button>
      </div>
      <section className='vl_dsh_bodypart_section pos_rel'>
        <div className='vl_listing_area'>
          <div className='vl_listing_row'>
            <div className='vl_listing_cell width20'>
              <h4 className='prj_name'>User Name</h4>
            </div>
            <div className='vl_listing_cell width20'>
              <p>Change Role</p>
            </div>

            <div className='vl_listing_cell width20'>
              <p>Email</p>
            </div>
            <div className='vl_listing_cell width20'>
              <p>Phone</p>
            </div>
            <div className='vl_listing_cell width20'>
              <p>Action</p>
            </div>
          </div>
          {Array.isArray(listMembersArray) &&
            listMembersArray.filter(item => item.mem_role !== 'Super Admin')

              .map((item, index) => (
                <div className="vl_listing_row" key={item.primary_key || index}>

                  <div className="vl_listing_cell width20">
                    <h4 className="prj_name">
                      {item.mem_fname} {item.mem_lname}
                    </h4>

                    <input type="hidden" value={item.primary_key} />

                    <span id="memroletext">Role : {item.mem_role}</span>
                    <span>Employee Id : {item.emp_auto_id}</span>
                    <span>Registration Date & Time : {item.reg_dt_tm}</span>
                    <span>Activation : {item.mem_activation}</span>
                  </div>

                  <div className="vl_listing_cell width20">
                    <select value={memberRoles[item.primary_key] || ''} onChange={(e) => setMemberRoles({ ...memberRoles, [item.primary_key]: e.target.value })}>
                      <option value=''>Change Role</option>
                      {roles.map((role) => (
                        <option key={role.primary_key} value={role.primary_key}>
                          {role.role_name}
                        </option>
                      ))}
                    </select>
                    <button title="Update member role" className="rightgap nopadding" onClick={() =>
                      updateMemRole(item.primary_key, item.permission)}>
                      <i className='ri-edit-circle-fill'></i>
                    </button>
                  </div>

                  <div className="vl_listing_cell width20">
                    <p>{item.mem_email}</p>
                  </div>

                  <div className="vl_listing_cell width20">
                    <p>{item.mem_phone}</p>
                  </div>

                  <div className="vl_listing_cell width20">
                    {item.block_user !== 'yes' ? (
                      <button
                        title="Block User"
                        className="rightgap backtranparent blockbtn"
                        onClick={() => blockUser(item.primary_key)}
                      >
                        <i className="ri-lock-line"></i>
                      </button>
                    ) : (
                      <button
                        title="Un-Block User"
                        className="rightgap backtranparent greenicon unblockbtn"
                        onClick={() => unblockUser(item.primary_key)}
                      >
                        <i className="ri-lock-unlock-line"></i>
                      </button>
                    )}

                    {item.delete_user !== 'yes' && (
                      <button
                        className="rightgap"
                        onClick={() => removeMem(item.primary_key)}
                      >
                        <i className="ri-delete-bin-3-fill"></i>
                      </button>
                    )}
                  </div>

                </div>
              ))}

        </div>
      </section>
      {showAlertBox && (
        <div className='vl_dsh_popup_vis'>
          <div className='alertbox'>
            <div className='alertheader'>
              <h3><i className='ri-alert-line'></i>Alert</h3>
            </div>
            <div className='contentarea'>
              <p>{alertMsg}</p>
            </div>
            <div className='alert_btns'>
              <button onClick={closeAlert}>Okay</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
